import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftBusinessIndexResponse } from '@/repositories/generated';

const content: GiftBusinessIndexResponse[] = [
  {
    giftBusinessId: '001',
    giftBusinessName: '〇〇市プレミアム付商品事業',
    giftIssuerId: 'ISS001',
    giftIssuerName: '〇〇市商品券事業協会',
    giftSalesManagementId: '0018',
    giftSalesManagementName: '値引プレミアム付電子商品券事業',
    salesStatus: 'NOT_STARTED',
    entryStatus: 'NOT_STARTED',
    salesStartsAt: '2024-01-01T00:00:00+09:00',
    salesEndsAt: '2024-06-30T00:00:00+09:00',
    entryStartsAt: '2023-12-01T00:00:00+09:00',
    entryEndsAt: '2023-12-31T23:59:59+09:00',
    expiresStartsAt: '2024-01-01T00:00:00+09:00',
    expiresEndsAt: '2024-12-31T23:59:59+09:00',
    ticketCount: 2,
  },
  {
    giftBusinessId: '001',
    giftBusinessName: '〇〇市プレミアム付商品事業',
    giftIssuerId: 'ISS001',
    giftIssuerName: '〇〇市商品券事業協会',
    giftSalesManagementId: '0021',
    giftSalesManagementName: '値引プレミアム付デジタル商品券値引き券',
    salesStatus: 'NOT_STARTED',
    entryStatus: 'OPEN',
    salesStartsAt: '2024-03-01T00:00:00+09:00',
    salesEndsAt: '2024-08-31T00:00:00+09:00',
    entryStartsAt: '2024-02-01T00:00:00+09:00',
    entryEndsAt: '2024-02-28T23:59:59+09:00',
    expiresStartsAt: '2024-03-01T00:00:00+09:00',
    expiresEndsAt: '2024-12-31T23:59:59+09:00',
    ticketCount: 1,
  },
  {
    giftBusinessId: '002',
    giftBusinessName: '〇〇市給付金',
    giftIssuerId: 'ISS002',
    giftIssuerName: '△△市福祉事業団',
    giftSalesManagementId: '0103',
    giftSalesManagementName: '給付型電子商品REMIXサービス',
    salesStatus: 'ON_SALE',
    entryStatus: 'ENDED',
    salesStartsAt: '2024-04-01T00:00:00+09:00',
    salesEndsAt: '2024-09-30T00:00:00+09:00',
    entryStartsAt: '2024-03-01T00:00:00+09:00',
    entryEndsAt: '2024-03-31T23:59:59+09:00',
    expiresStartsAt: '2024-04-01T00:00:00+09:00',
    expiresEndsAt: '2025-03-31T23:59:59+09:00',
    ticketCount: 3,
  },
  {
    giftBusinessId: '003',
    giftBusinessName: '〇〇市プレミアム付商品券',
    giftIssuerId: 'ISS003',
    giftIssuerName: '□□商工会議所',
    giftSalesManagementId: '0002',
    giftSalesManagementName: '券売所用商品券（3期）',
    salesStatus: 'ENDED',
    entryStatus: 'ENDED',
    salesStartsAt: '2023-07-01T00:00:00+09:00',
    salesEndsAt: '2023-12-31T00:00:00+09:00',
    entryStartsAt: '2023-06-01T00:00:00+09:00',
    entryEndsAt: '2023-06-30T23:59:59+09:00',
    expiresStartsAt: '2023-07-01T00:00:00+09:00',
    expiresEndsAt: '2024-06-30T23:59:59+09:00',
    ticketCount: 1,
  },
];

const loopContent = new Array<string>(10)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const giftBusiness = http.get(
  createMockEndpoint('/gift_business'),
  async () => {
    await delay(500);
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 10,
        paged: true,
        unpaged: false,
      },
      last: false,
      totalPages: 4,
      totalElements: 35,
      size: 10,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 10,
      empty: false,
    }, { status: 200 });
  },
);

export default giftBusiness;
